import { render, staticRenderFns } from "./SafariDetail.vue?vue&type=template&id=06ae02b8&"
import script from "./SafariDetail.vue?vue&type=script&lang=js&"
export * from "./SafariDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports